var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMemealertsCircle = function SvgMemealertsCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 85,
    height: 90,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#memealerts-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 41,
    fill: "#5513B8",
    stroke: "#fff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#memealerts-circle_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#memealerts-circle_svg__c)",
    d: "M29.757 63.266q-1.39 0-3.322-.972a15.6 15.6 0 0 1-3.323-2.43q-1.389-1.398-1.389-2.31-.061-.972.544-4.07.664-3.16.845-4.071.242-1.215.906-4.436.665-3.28 1.088-6.076l.483-2.855q1.148-6.805 2.114-11.059 1.028-4.253 2.054-4.253t2.778.85a15 15 0 0 1 3.383 2.188q1.57 1.275 2.114 2.43Q39 28.39 40.57 35.56q1.088 4.983 1.631 6.866 2.598-3.95 6.645-12.09 2.597-5.166 3.926-7.353 1.39-2.247 2.477-2.248 1.148 0 3.08 1.033 1.994 1.034 3.444 2.43 1.51 1.398 1.51 2.43 0 .852-.725 4.8l-.906 4.862-1.57 8.567q-.604 3.585-1.27 9.417-.603 4.983-1.087 6.988-.422 2.004-1.389 2.005-1.39 0-3.322-.972a15.6 15.6 0 0 1-3.322-2.43q-1.39-1.398-1.39-2.31-.06-.79.423-3.341.544-2.613 1.208-5.894.544-2.613.604-2.977l2.175-6.745-.846-.303-.604 1.215q-2.355 4.86-3.805 7.595-1.39 2.673-2.296 3.828-.603.728-2.174 1.215a11.8 11.8 0 0 1-3.081.425q-1.57 0-2.114-.547-.544-.486-.967-2.005a214 214 0 0 1-1.027-4.86q-.12-.67-.664-3.22a50 50 0 0 0-1.208-4.74l-.423 7.656q-.604 3.585-1.269 9.417-.604 4.983-1.087 6.988-.423 2.004-1.39 2.005"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m25.219 64.74-.091-.049a18.4 18.4 0 0 1-3.938-2.894c-.553-.557-1.061-1.156-1.445-1.794-.362-.6-.718-1.41-.74-2.357-.048-1.07.216-2.751.594-4.688l.008-.04c.444-2.11.723-3.452.84-4.042.163-.82.467-2.306.909-4.45q.652-3.221 1.062-5.936l.005-.032.003-.015.483-2.855c.77-4.562 1.484-8.304 2.144-11.21l.009-.036c.356-1.476.752-2.765 1.223-3.74.232-.48.552-1.035 1.009-1.507C27.752 18.62 28.58 18 29.757 18c1.31 0 2.685.505 3.944 1.115a17.8 17.8 0 0 1 3.95 2.55c1.187.968 2.231 2.08 2.838 3.367l.027.06c.775 1.754 1.672 5.15 2.708 9.88v.001l.05.227a207 207 0 0 0 3.14-6.089l.005-.011c1.735-3.448 3.085-5.984 4.033-7.544l.01-.017c.53-.857 1.124-1.657 1.802-2.273.655-.594 1.668-1.266 2.984-1.266 1.449 0 2.959.608 4.34 1.344 1.52.79 2.877 1.739 4.044 2.86C64.704 23.2 66 24.707 66 26.628c0 .522-.095 1.263-.212 2.036-.127.84-.314 1.931-.558 3.26l-.906 4.86-.001.008-1.566 8.54c-.39 2.32-.806 5.398-1.245 9.253l-.002.02c-.4 3.293-.774 5.751-1.135 7.263-.173.806-.454 1.702-.98 2.46-.593.856-1.62 1.672-3.06 1.672-1.518 0-3.06-.518-4.538-1.26l-.091-.049a18.4 18.4 0 0 1-3.937-2.894c-.554-.557-1.062-1.156-1.446-1.794-.359-.597-.712-1.398-.738-2.337-.03-.535.026-1.138.095-1.687.08-.624.203-1.375.366-2.238-.712.467-1.508.786-2.261 1.02l-.093.026c-1.26.341-2.524.52-3.787.52-1.105 0-2.786-.141-3.979-1.292a4.7 4.7 0 0 1-.808-1.012q-.09.769-.184 1.582l-.002.02c-.4 3.292-.774 5.75-1.135 7.262-.173.806-.454 1.703-.98 2.46-.593.857-1.62 1.673-3.06 1.673-1.519 0-3.061-.518-4.538-1.26m5.927-3.48q.483-2.004 1.087-6.987.535-4.692 1.03-7.93a109 109 0 0 1 .239-1.487l.423-7.656a50 50 0 0 1 1.208 4.74 184 184 0 0 1 .664 3.22l.019.09.209 1.027q.5 2.445.8 3.743.422 1.52.966 2.005.543.547 2.114.547 1.51 0 3.08-.425 1.572-.487 2.175-1.215.88-1.122 2.216-3.675l.08-.153a140 140 0 0 0 1.223-2.368q1.116-2.202 2.582-5.227l.604-1.215.846.303-2.175 6.745q-.059.355-.578 2.851l-.026.126q-.665 3.28-1.208 5.894-.483 2.551-.423 3.341 0 .912 1.39 2.31a15.6 15.6 0 0 0 3.322 2.43q1.932.972 3.322.972.967 0 1.39-2.005.483-2.005 1.087-6.988.665-5.832 1.268-9.417l1.57-8.567.907-4.861q.725-3.95.725-4.8 0-1.033-1.51-2.43-1.45-1.398-3.443-2.43-1.934-1.035-3.081-1.034-1.087 0-2.477 2.248-1.329 2.189-3.926 7.352-2.644 5.319-4.669 8.848a63 63 0 0 1-1.976 3.243q-.348-1.205-.919-3.681-.32-1.392-.712-3.184-1.57-7.17-2.537-9.358-.543-1.155-2.114-2.43a15 15 0 0 0-3.383-2.187q-1.75-.85-2.778-.85t-2.054 4.252q-.966 4.254-2.114 11.059l-.483 2.855a125 125 0 0 1-1.088 6.076 749 749 0 0 0-.906 4.436q-.18.91-.845 4.07-.604 3.099-.544 4.071 0 .912 1.39 2.31a15.6 15.6 0 0 0 3.322 2.43q1.933.972 3.322.972.966 0 1.39-2.005",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "memealerts-circle_svg__a",
    width: 85,
    height: 90,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3092_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3092_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "memealerts-circle_svg__b",
    width: 67,
    height: 68,
    x: 9,
    y: 8,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.92549 0 0 0 0 0.301961 0 0 0 0 0.427451 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3092_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3092_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "memealerts-circle_svg__c",
    x1: 41.99,
    x2: 41.99,
    y1: 24.857,
    y2: 72.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })))));
};
export default SvgMemealertsCircle;